"use client";

export const OPEN_COOKIE_PREFERENCES_EVENT = "mot-open-cookie-preferences";

export function CookiePreferencesTrigger() {
  return (
    <button
      type="button"
      className="font-medium text-mot-teal underline decoration-mot-teal/40 underline-offset-2 hover:text-mot-teal-light"
      onClick={() => {
        window.dispatchEvent(new CustomEvent(OPEN_COOKIE_PREFERENCES_EVENT));
      }}
    >
      Cookie preferences
    </button>
  );
}
